import React from 'react';
import { useStyles } from './Menu.styles';

interface MenuProps {
  isFullscreen: boolean;
  isSidebarVisible: boolean;
}

export const Menu: React.FC<MenuProps> = ({ isFullscreen, isSidebarVisible, children }) => {
  const classes = useStyles();

  return (
    <div
      className={[
        isFullscreen
          ? `${classes.containerFullscreen} ${classes.container}`
          : `${classes.containerNonFullscreen} ${classes.container}`,
        !isSidebarVisible ? `${classes.containerNonSidebar} ${classes.container}` : `${classes.container}`,
      ].join(' ')}
    >
      {children}
    </div>
  );
};
